import { DokumenTindakLanjutStep2 } from 'app/KinerjaPage/pages/PelaksanaanV2/DokumenTindakLanjut/DokumenTindakLanjutStep2'
import { PageGuardPelaksanaan } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <KinerjaTipeProvider tipe="SPF">
      <PageGuardPelaksanaanDate>
        <PageGuardPelaksanaan pageState="DOCUMENT_FOLLOW_UP">
          <DokumenTindakLanjutStep2 />
        </PageGuardPelaksanaan>
      </PageGuardPelaksanaanDate>
    </KinerjaTipeProvider>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}
